import jp from "jsonpath";
import { checkAutoSubmitEmail } from "./checkAutoSubmitEmail";
import { getAutoResponse } from "./getAutoResponse";
import { getGigitData } from "./getGigitData";

const basicSelfieTags = [{ api_key: 'Acne', tag_value: 'acne' }, { api_key: 'Wrinkles', tag_value: 'wrinkles' }, { api_key: 'Rosacea', tag_value: 'rosacea' }, { api_key: 'Dark Spots', tag_value: 'dark_spots' }, { api_key: 'Dark Circles', tag_value: 'dark_circles' }]

interface AnswerResponse {
    inputLabel?: string;
    inputType?: string;
    inputValue?: string;
    tag?: string;
}

interface Response {
    _id?: string;
    selfieID?: string;
    questionType: string;
    answerResponse: AnswerResponse[];
}

const getSelfieId = (responses: Response[]) => {
    for (const { questionType, selfieID } of responses) {
        if (questionType === "selfie" && selfieID) {
            return selfieID;
        }
    }
    return "";
}

export const getFormData = (responses: Response[]) => {
    return responses.reduce((formData, response) => {
        const { questionType, answerResponse, _id, action } = response;
        if (questionType === "email") {
            formData["email"] = answerResponse[0]?.inputValue
            action === "autoSubmit" ? formData["autoSubmitEmail"] = true : null;
        }
        if (questionType === "input" && answerResponse.length > 0 && _id) {
            answerResponse.forEach((response) => {
                const keyName = response?.tag ? response.tag : `${response.inputLabel.replace(/\s/g, "")}_${_id}`;
                formData[keyName] = response?.inputValue || "";
                action === "autoSubmit" ? formData["autoSubmitEmail"] = true : null;
            });
        }

        return formData;
    }, {} as { [key: string]: string | boolean });
}

const getCustomSelfieTags = (customSelfieTags, selfieResponse, extractedTags) => {
    if (!customSelfieTags || !selfieResponse) return extractedTags;
    let customTags = [];
    customSelfieTags.forEach((condtion) => {
        const conditionFn = new Function('selfieResponse', 'jp', condtion.tagCondition);
        if (conditionFn(selfieResponse, jp)) {
            customTags.push(...condtion.tagsList);
        }
    })
    return [...extractedTags, ...customTags];
}

export const extractTags = (responses: Response[], settings: object = {}, customSelfieTags: object) => {
    let extractedTags = responses
        .map(({ questionType, answerResponse }) => {
            if (["single", "multi", "input"].includes(questionType)) {
                return answerResponse.map((response) => {
                    if (response.tag) {
                        return response.tag.split(',');
                    }
                    return [];
                }).flat();
            }
            return [];
        })
        .flat();

    const selfieResponse = responses.find(({ questionType }) => questionType === "selfie")?.selfieResponse[0]?.beta;

    extractedTags = getCustomSelfieTags(customSelfieTags, selfieResponse, extractedTags);

    if (settings.selfieBasicMap && selfieResponse) {
        const matchedRegions: string[] = [];
        basicSelfieTags.forEach((tag) => {
            const skincondition = jp.value(selfieResponse, `$..['${tag.api_key}']`)
            if (skincondition.loc.length > 0) {
                const regions = jp.value(skincondition, '$..regions');
                matchedRegions.push(...regions.map((region: string) => `${tag.tag_value}_${region}`));
                matchedRegions.push(tag.tag_value);
            }
        })
        return [...extractedTags, ...matchedRegions];
    }
    return extractedTags;
}

const constructQuizResponse = (responses: Response[], formId: string, shopId: string, data: object, customerEmail: string = "") => {
    const gigitLocalId = data?.settings?.gigitData?.localId ?? "";

    if (data?.settings?.autoSubmitEmail && customerEmail) {
        data.questionList.forEach((question, index) => {
            if (checkAutoSubmitEmail(index, data, customerEmail)) {
                const autoResponse = getAutoResponse(index, data, customerEmail);
                if (autoResponse) {
                    responses.splice(index, 0, autoResponse);
                }
            }
        })
    }


    return {
        form_id: formId,
        shop_id: shopId,
        responses: {
            ...(gigitLocalId ? {
                gigitData: {
                    id: getGigitData(gigitLocalId),
                }
            } : {}),
            id: getSelfieId(responses),
            app_version: `/quiz_inline/v${import.meta.env.VITE_RELEASE_VERSION}`,
            parent_cookies: document.cookie,
            parent_referrer: document.referrer,
            parent_url: window.location.href,
            selfie_user: "mango",
            form: getFormData(responses),
            tags: [...extractTags(responses, data?.settings, data?.customSelfieTags), "tangent_quiz"],
            raw_response: responses,
            other_data: {
                redirection_url: data?.quiz?.meta?.recoUrl
            },
        }
    };
}

export default constructQuizResponse;